import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1D1C1A',
      contrastText: '#ffffff',
    },
  },
});
